import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = 576;

/**
 * Custom hook to detect if the current viewport is mobile-sized.
 * Returns true when window width is <= 576px (phone breakpoint).
 * SSR-safe: defaults to false on server.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    // SSR-safe: check if window exists
    if (typeof window === "undefined") return false;
    return window.innerWidth <= MOBILE_BREAKPOINT;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const handleResize = () => {
      // Debounce for performance
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
      }, 100);
    };

    // Set initial value
    setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  return isMobile;
}

export default useIsMobile;



